if (document.getElementById('matchstic-reel-dialog')) {
    const dialog = document.getElementById('matchstic-reel-dialog');
    const openButtons = document.querySelectorAll('.jsReelThumbnailButton');
    const closeButton = dialog.querySelector('.jsVideoPopupClose');
    const vimeoVideo = document.getElementById('matchstic-reel-video');
    let currentButtonVideo = null;

    // Load the video if it hasn’t been loaded yet
    function ensureVideoIsLoaded(videoElement) {
        if (videoElement && !videoElement.hasAttribute('src')) {
            const src = videoElement.getAttribute('data-src');
            if (src) {
                console.log(`Loading video for thumbnail click: ${src}`);
                videoElement.setAttribute('src', src);
                videoElement.load();
            }
        }
    }

    openButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            currentButtonVideo = btn.querySelector('video');

            // Ensure the video is loaded
            ensureVideoIsLoaded(vimeoVideo);

            if (!document.startViewTransition) {
                dialog.showModal();
                playVideo();
            } else {
                currentButtonVideo.style.viewTransitionName = "active-video";

                // Start transition with the View Transitions API
                document.startViewTransition(() => {
                    currentButtonVideo.style.viewTransitionName = "";
                    dialog.showModal();
                    playVideo();
                });
            }
        });
    });

    closeButton.addEventListener('click', () => handleVideoPopupClose());

    async function handleVideoPopupClose() {
        try {
            if (!document.startViewTransition) {
                dialog.close();
                pauseAndResetVideo();
            } else {
                currentButtonVideo.style.viewTransitionName = "active-video";
                let transition = document.startViewTransition(() => {
                    currentButtonVideo.style.viewTransitionName = "";
                    dialog.close();
                    pauseAndResetVideo();
                });
                await transition.finished; // Wait for transition to complete
            }
        } catch (error) {
            console.error(error);
        }
    }

    dialog.addEventListener('close', () => {
        pauseAndResetVideo();
    });

    function playVideo() {
        ensureVideoIsLoaded(vimeoVideo); // Ensure the video is loaded before playing
        if (vimeoVideo && typeof vimeoVideo.play === 'function') {
            console.log('Playing video...');
            vimeoVideo.play(); // Start playback
        } else {
            console.warn('vimeoVideo element is not initialized or play() is not available.');
        }
    }

    function pauseAndResetVideo() {
        if (vimeoVideo) {
            console.log('Pausing and resetting video...');
            // Pause the video
            vimeoVideo.pause();

            // Reset the video to start from 0
            vimeoVideo.currentTime = 0;
        } else {
            console.warn('vimeoVideo element is not found or not initialized.');
        }
    }
}

/**
 * Vimeo Video Element
 */

document.addEventListener('DOMContentLoaded', () => {
    let hasInteracted = false;
    let observer;

    // Function to load all Vimeo videos
    function loadAllVimeoVideos() {
        const videos = document.querySelectorAll('vimeo-video[data-src]');
        // console.log('Vimeo videos found:', videos.length);

        videos.forEach((videoElement) => {
            const src = videoElement.getAttribute('data-src');
            if (src && !videoElement.getAttribute('src')) {
                // console.log('Loading video:', src);
                videoElement.setAttribute('src', src);
                videoElement.load();

                videoElement.addEventListener('load', () => {
                    videoElement.classList.remove('opacity-0');
                    videoElement.classList.add('opacity-100');
                });
            }
        });
    }

    // Function to handle user interaction (scroll or mouse move)
    function handleUserInteraction() {
        if (!hasInteracted) {
            hasInteracted = true;
            // console.log('User interaction detected, loading videos');
            loadAllVimeoVideos();

            window.removeEventListener('mousemove', handleUserInteraction);
            window.removeEventListener('scroll', handleUserInteraction);
        }
    }

    // Initialize MutationObserver for the container
    function observeFilterResultsContainer() {
        const container = document.querySelector('#jsFilterResultsContainer');
        // if (!container) {
        //     // console.error('jsFilterResultsContainer not found!');
        //     return;
        // }

        // Disconnect existing observer if it's active
        if (observer) {
            observer.disconnect();
            // console.log('Disconnected existing observer');
        }

        observer = new MutationObserver((mutations) => {
            // console.log('Mutation observed:', mutations);
            if (hasInteracted) {
                loadAllVimeoVideos();
            }
        });

        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true,
            });
        }

        // console.log('Observer attached to jsFilterResultsContainer');
    }

    // Reinitialize observer and load videos after Sprig updates
    document.addEventListener('htmx:afterSwap', () => {
        // console.log('Sprig component updated, reinitializing observer');
        observeFilterResultsContainer(); // Reattach observer
        if (hasInteracted) {
            loadAllVimeoVideos(); // Reload videos immediately
        }
    });

    // Initial setup
    window.addEventListener('scroll', handleUserInteraction);
    window.addEventListener('mousemove', handleUserInteraction);

    observeFilterResultsContainer(); // Attach observer initially
});